import actions from './actions'
import crudReducers from '../../crud/reducers'

const dataPropName = 'model'

const initState = {
  list: [],
  listLoaded: false,
  loading: false,
  loaded: false,
  error: false,
  modalActive: false,
  [dataPropName]: {
    dummyProp: ''
  }
}

const reducers = crudReducers(actions, dataPropName, initState)

export default reducers
